import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Icon,
} from '@mui/material'

/**
 * Reusable modal shell for future screens.
 */
const AppModal = ({
    open,
    onClose,
    title,
    children,
    actions = null,
    maxWidth = 'sm',
    fullWidth = true,
    showCloseButton = true,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
            {title ? (
                <DialogTitle sx={{ pr: 6 }}>
                    {title}
                    {showCloseButton && onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    ) : null}
                </DialogTitle>
            ) : null}
            <DialogContent dividers>{children}</DialogContent>
            {actions ? <DialogActions>{actions}</DialogActions> : null}
        </Dialog>
    )
}

export default AppModal
